import { ChangeEvent, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import './styles.css';
import { ErrorMessage } from '@/components/Message/ErrorMessage';

interface InputProps
  extends React.PropsWithRef<JSX.IntrinsicElements['input']> {
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  errorMessage?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  containerClassName?: string;
  inputWrapperClassName?: string;
  inputClassName?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      placeholder,
      type,
      autoComplete = 'on',
      defaultValue = '',
      value,
      onInput,
      maxLength,
      errorMessage,
      leftIcon,
      rightIcon,
      containerClassName,
      inputWrapperClassName,
      inputClassName,
      onChange,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        className={twMerge('flex flex-1 flex-col gap-0.75', containerClassName)}
      >
        <div
          className={twMerge(
            'flex flex-1 items-center relative',
            inputWrapperClassName
          )}
        >
          {leftIcon && (
            <div className="flex justify-center items-center absolute left-3">
              {leftIcon}
            </div>
          )}
          {rightIcon && (
            <div className="flex justify-center items-center absolute right-3">
              {rightIcon}
            </div>
          )}
          <input
            ref={ref}
            className={twMerge(
              'input h-11 font-normal text-gray-5B5B5B bg-gray-100',
              leftIcon && 'pl-9',
              rightIcon && 'pr-9',
              errorMessage &&
                'border-danger hover:border-danger focus:border-danger',
              inputClassName
            )}
            placeholder={placeholder}
            type={type}
            autoComplete={autoComplete}
            {...(value !== undefined ? { value } : { defaultValue })}
            onInput={onInput}
            maxLength={maxLength}
            onChange={onChange}
            {...rest}
          />
        </div>
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    );
  }
);
